import { useMutation, useQuery } from '@apollo/client'
import { Button, Form, Select } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import React, { useMemo } from 'react'
import { BATIMENTS_QUERY } from '../../apollo/query/batiment.query'
import { DEMANDE_UPDATE, EQUIPEMENT_INSERT_MUTATION } from '../../apollo/mutation/demande.mutation'
import { EVENEMENTS } from '../../apollo/query/demande.query'
import { TYPE_EQUIPEMENT_EQUIPEMENT } from '../../apollo/query/typeequipement.query'
import { D4_Batiment, D4_Fn_View_Demande, D4_Typeequipement } from '../../types'

interface CreateEquipementInput {
  equipementCoproId: number
  equipementBatimentId: number
  typeEquipementId: number
  equipementLibelle: string
  demandeId: number
}

const SelectEquipement = ({ demande }: { demande: D4_Fn_View_Demande }) => {
  const [updateDemande, { loading }] = useMutation(DEMANDE_UPDATE, {
    refetchQueries: [{ query: EVENEMENTS, variables: { id: demande.id } }],
    awaitRefetchQueries: true,
  })

  const [createEquipementAndUpdateDemande] = useMutation<{}, CreateEquipementInput>(EQUIPEMENT_INSERT_MUTATION, {
    refetchQueries: [
      { query: EVENEMENTS, variables: { id: demande.id } },
      {
        query: TYPE_EQUIPEMENT_EQUIPEMENT,
        variables: {
          coproprieteid: demande.coproprieteid,
        },
      },
    ],
  })

  const { data: typeEquipement } = useQuery<{ typeEquipement: D4_Typeequipement[] }, { coproprieteid: number }>(
    TYPE_EQUIPEMENT_EQUIPEMENT,
    {
      variables: {
        coproprieteid: demande.coproprieteid,
      },
    }
  )

  const { data: batiments } = useQuery<{ batiments: D4_Batiment[] }>(BATIMENTS_QUERY, {
    variables: {
      coproprieteid: demande.coproprieteid,
    },
  })

  const options = useMemo(
    () => ({
      typeEquipements:
        typeEquipement?.typeEquipement.map((eq) => ({
          label: eq.typeequipement,
          value: eq.id,
          // options: eq.equipements.map((e) => ({ label: e.libelle, value: e.id })),
        })) ?? [],
      batiments: [
        { label: 'Général', value: -1 },
        ...(batiments?.batiments.map((b) => ({ value: b.id, label: b.libelle })) ?? []),
      ],
    }),
    [batiments?.batiments, typeEquipement?.typeEquipement]
  )

  const [form] = useForm()

  return (
    <Form
      form={form}
      name="change-equipement"
      initialValues={{
        batiment: demande.batimentid ?? -1,
        equipement: demande.typeequipementid,
      }}
      layout="inline"
      onFinish={(values) => {
        const { batiment, equipement } = values
        const bat = batiments?.batiments.find((b) => b.id === batiment)
        const te = typeEquipement?.typeEquipement.find((te) => te.id === equipement)
        const equipementAlreadyExist = te?.equipements.find((e) => {
          /**
           * -1 = equipement sur la copro (Général)
           */
          return batiment === -1 ? e.copropriete_id === demande.coproprieteid : e.batiment_id === batiment
        })

        if (equipementAlreadyExist) {
          updateDemande({
            variables: {
              id: demande.id,
              data: {
                equipement_id: equipementAlreadyExist.id,
              },
            },
          })
        } else {
          createEquipementAndUpdateDemande({
            variables: {
              equipementCoproId: batiment === -1 ? demande.coproprieteid : null,
              equipementBatimentId: batiment === -1 ? null : batiment,
              typeEquipementId: equipement,
              equipementLibelle: `${te?.typeequipement ?? ''} ${bat?.libelle ?? ''}`.trim(),
              demandeId: demande.id,
            },
          })
        }
      }}
    >
      <Form.Item name="batiment">
        <Select
          options={options.batiments}
          showArrow
          showSearch
          getPopupContainer={(node) => node}
          optionFilterProp="label"
          style={{ width: '150px' }}
          placeholder="Batiment"
        />
      </Form.Item>
      <Form.Item name="equipement">
        <Select
          options={options.typeEquipements}
          showArrow
          showSearch
          getPopupContainer={(node) => node}
          optionFilterProp="label"
          style={{ width: '250px' }}
          placeholder="Équipement"
        />
      </Form.Item>
      <Button htmlType="submit" type="primary" loading={loading}>
        OK
      </Button>
    </Form>
  )
}

export default SelectEquipement
